import React, { useCallback } from 'react'
import { ListItem as MuiListItem } from '@material-ui/core'
import { logClickEvent } from '~/common/tracking/event-client.tracking'

export const ListItem = ({ children, ...props }) => {
	const handleClick = useCallback(() => {
		if (props.onTrackingEvent) {
			props.onTrackingEvent()
		} else if (props.eventId) {
			logClickEvent(props.eventId, {
				...props.eventParams,
			})
		}
		props.onClick()
	}, [props])

	return (
		<MuiListItem {...props} onClick={handleClick}>
			{children}
		</MuiListItem>
	)
}
